"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = SVBAPICards;
require("core-js/modules/esnext.iterator.map.js");
var _react = _interopRequireDefault(require("react"));
var _svbReactComponents = require("@svb/svb-react-components");
var _helpers = require("./js/helpers");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
/**
 * SVBAPICards Component
 * By Prashant Bhatt <pbhatt@svb.com> (www.svb.com)
 * Summary
 * to render a API Cards
 */

function SVBAPICards(props) {
  const {
    apisJson,
    cardOptions
  } = props;
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "cards"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "row"
  }, apisJson.map((item, index) => {
    const btnLink = item.link ? item.link : "/api-docs/".concat(item.api_name, "/").concat(item.version);
    const btnText = cardOptions !== null && cardOptions !== void 0 && cardOptions.overrideLearnMoreElement ? cardOptions === null || cardOptions === void 0 ? void 0 : cardOptions.overrideLearnMoreElement : item.buttonLabel ? item.buttonLabel : 'Learn more';
    const cardTestid = (0, _helpers.slugCreator)('card-' + item.api_name);
    const learnMoreTestid = (0, _helpers.slugCreator)(btnText + '-' + item.api_name);
    return /*#__PURE__*/_react.default.createElement("div", {
      key: index,
      className: "col-lg-4 col-md-6 col-sm-12 align-item-stretch d-flex mb-4 gy-3"
    }, /*#__PURE__*/_react.default.createElement(_svbReactComponents.SVBCard, {
      cardIcon: item.cardIcon,
      description: item.api_description,
      title: item.api_display_name,
      link: btnLink,
      buttonLabel: btnText,
      cardOptions: cardOptions,
      datatestid: {
        card: cardTestid,
        learnMore: learnMoreTestid
      }
    }));
  })));
}